<template lang="html">
  <div style="overflow-x: hidden">
    <div class="flex items-center justify-center">
      <div v-if="loading_chord" class="row center-xs">
        <pl-spinner class="x4" style="margin-top: 15%"></pl-spinner>
      </div>
      <chord-diagram
        v-else-if="!loading_chord && !show_empty_message"
        :summary="summary"
        @showEmptyMessage="show_empty_message = true"
      />
      <img v-else src="/static/D3ChordEmpty.png" class="empty-message-size" />
      <div class="position-info-button">
        <pl-button @click.native="show_info = true" class="pl-icon">
          <i class="fas fa-info-circle" />
        </pl-button>
      </div>
    </div>
    <pl-dialog
      v-if="show_info"
      @close="show_info = false"
      header="The Comment Chord shows how many comments and replies each student submitted."
    >
      <p class="italics pl-subheading tc">
        Hover over to show the relationship between two students!
      </p>
      <div class="sharing-info ma3" v-if="!getCurrentRT.is_sandbox">
        <section
          class="flex justify-center items-center"
          v-if="hasTeacherPermissionsInCourse"
        >
          <template>
            <p class="mr3 pl-caption">
              Share this visual and become a
              <b class="clickable" @click="toBlogPost">Parlay Trailblazer!</b>
            </p>
          </template>
          <template v-if="!show_empty_message">
            <img
              src="/static/shareOnTW.svg"
              @click="shareOnTW"
              class="social-icons clickable"
            />
            <img
              src="/static/shareOnFB.svg"
              @click="shareOnFB"
              class="social-icons clickable"
            />
          </template>
          <template v-else>
            <img src="/static/shareOnTW_disabled.svg" class="social-icons" />
            <img src="/static/shareOnFB_disabled.svg" class="social-icons" />
          </template>
        </section>
        <div class="pl-caption">
          Students' names will not be visible in the public version of the graph
        </div>
      </div>
      <pl-button @click.native="show_info = false" class="pl-primary">
        OK
      </pl-button>
    </pl-dialog>
  </div>
</template>

<script>
  import chordDiagram from 'components/dataVisualization/d3js/chordDiagram.vue';
  import createChordDiagram from 'features/onlineRoundtables/services/dataVisualization/createChordDiagram';
  import createChordDiagramPublic from 'features/onlineRoundtables/services/dataVisualization/createChordDiagramPublic';
  import { mapGetters } from 'vuex';
  import URLPath from 'services/apiConfigs';

  export default {
    components: {
      chordDiagram,
    },
    data() {
      return {
        summary: [],
        show_empty_message: false,
        loading_chord: true,
        loading_page: true,
        show_info: false,
      };
    },
    computed: {
      ...mapGetters(['getCurrentRT', 'hasTeacherPermissionsInCourse']),
      sharing_url() {
        const roundtableID = this.$route.params.roundtableID;
        return `${URLPath.apiURL}/api/roundtables/${roundtableID}/chord`;
      },
    },
    methods: {
      toParlaySite() {
        window.open('https://parlayideas.com/');
      },
      toBlogPost() {
        window.open(
          'https://parlayideas.com/revolutionize-discussion-become-a-parlay-trailblazer/'
        );
      },
      shareOnTW() {
        const rtTitle = this.getCurrentRT.title;
        const url = this.formatParam(this.sharing_url);
        const text = this.formatParam(
          `Check out this Comment Chord from our class discussion "${rtTitle}" on @parlayideas`
        );
        window.open(
          `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
          '',
          'scrollbars=yes,width=650,height=280'
        );
      },
      shareOnFB() {
        // FB.ui(
        //   {
        //     method: 'share',
        //     href: this.formatParam(this.sharing_url),
        //   },
        //   function (response) {}
        // );
      },
      formatParam(param) {
        return param
          .replace(/%/g, '%25')
          .replace(/ /g, '%20')
          .replace(/\$/g, '%24')
          .replace(/#/g, '%23');
      },
    },
    created() {
      // Facebook Init
      // window.fbAsyncInit = () => {
      //   FB.init({
      //     appId: '1550372328564661',
      //     autoLogAppEvents: true,
      //     xfbml: true,
      //     version: 'v2.12',
      //   });
      // };
      // (function (d, s, id) {
      //   var js,
      //     fjs = d.getElementsByTagName(s)[0];
      //   if (d.getElementById(id)) {
      //     return;
      //   }
      //   js = d.createElement(s);
      //   js.id = id;
      //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
      //   fjs.parentNode.insertBefore(js, fjs);
      // })(document, 'script', 'facebook-jssdk');
    },
    mounted() {
      if (this.$route.name === 'walkthrough.feed') {
        createChordDiagramPublic('e7b41d42-b980-4ee2-aff4-b6dfea324ecf')
          .then((response) => {
            response.data.d3information.splice(10, 1);
            this.summary = response.data.d3information;
            this.loading_chord = false;
            this.loading_page = false;
          })
          .catch(console.error);
      } else {
        createChordDiagram(this.$route.params.roundtableID)
          .then((response) => {
            this.summary = response.data.d3information;
            this.loading_chord = false;
            this.loading_page = false;
          })
          .catch(console.error);
      }
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .position-info-button
    margin-right: -30px;
  .empty-message-size
    width: 400px;
    height: 400px;
  .social-icons
    height: 25px
    margin: 0px 10px
</style>



// WEBPACK FOOTER //
// roundtableSummaryChordDiagram.vue?0de23a14